/**
 * Terminology (Phase 7) — never interchange these labels.
 *
 * - Unknown — value should exist but is currently unavailable
 * - Not configured — user has not configured the feature
 * - Not available — feature/API is not implemented
 * - Failed — verification ran and failed
 * - Not monitored — subsystem probe not implemented (runtime health)
 * - Not scanned — Runtime Doctor has not run for this tenant
 */
export const LABEL = {
  unknown: "Unknown",
  notConfigured: "Not configured",
  notAvailable: "Not available",
  failed: "Failed",
  /** Subsystem probes (DB/Queue/Disk/Memory) — neutral, not Unknown. */
  notMonitored: "Not monitored",
  /** @deprecated use notMonitored */
  notMonitoredYet: "Not monitored",
  notScanned: "Not scanned",
} as const;

export type TrustUnavailableLabel =
  | typeof LABEL.unknown
  | typeof LABEL.notAvailable
  | typeof LABEL.notConfigured
  | "Awaiting verification"
  | "Coming soon";
